import {AxiosError} from 'axios'
import {useEffect} from 'react'
import {useSelectDeviceId, useSelectInputSectionValue} from '../../../_metronic/layout/core'
import {awsHomePublishData} from '../../modules/auth/core/_requests'

function Start({item, index1, index2, deviceCode, experimentId, circuitId}: any) {
  const {SelectDeviceId} = useSelectDeviceId()
  const {SelectInputSectionValue, setSelectInputSectionValue} = useSelectInputSectionValue()

  const sendAwsData = async (numArr: any) => {
    try {
      if (SelectDeviceId.length > 0) {
        const requests = SelectDeviceId.map(async (id) => {
          try {
            // Her bir id için ayrı ayrı awsPublishData fonksiyonunu çağırıyoruz
            const response = await awsHomePublishData(id, experimentId, circuitId, {
              device: deviceCode,
              degerlers: numArr,
            })
            return response.data
          } catch (err) {
            // İstek sırasında bir hata olursa, hata nesnesini diziye ekliyoruz
            return Promise.reject(err)
          }
        })

        // Tüm istekler tamamlandığında çalışacak kod
        const results = await Promise.all(requests)
        //  console.log(results) // Tüm sonuçları görebilirsiniz
      } else {
        //console.error('SelectDeviceId boş!')
      }
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  // 👇 SelectInputSectionValue Matriksi içerisindeki ilgili alanı güncelliyoruz.
  function handleSetList(value: any) {
    const newData = SelectInputSectionValue
    if (newData && newData[index1] && newData[index1][index2]) {
      newData[index1][index2] = value
    } else {
      console.error('Geçersiz indeksler!')
    }
    return newData
  }

  // 👇 Gelen String Dizileri Array'e Çevirme
  const calculateArrayValue = (input: string) => {
    const numbersString = input.match(/\[(.*?)\]/g)

    if (numbersString) {
      const result = numbersString.map((str) => str.replace(/\[|\]/g, '').split(',').map(Number))
      return result
    }
    return null
  }

  const handleSendData = (value: any) => {
    const newValue = calculateArrayValue(value)
    let newList = handleSetList(newValue)
    setSelectInputSectionValue(newList)
    sendAwsData(newValue)
  }

  useEffect(() => {
    // buttonHandler(item[0].value)
    // sendAwsData(calculateArrayValue(item[0].value))
    // sendAwsData([JSON.parse(item[0].value)])
    if (SelectInputSectionValue) {
      const timeoutId = setTimeout(() => {
        handleSendData(item[0].value)
      }, 500)

      return () => clearTimeout(timeoutId)
    }
  }, [SelectInputSectionValue])

  return <div></div>
}

export default Start
